import { render, staticRenderFns } from "./sale-order.vue?vue&type=template&id=72e8adca&"
import script from "./sale-order.vue?vue&type=script&lang=js&"
export * from "./sale-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports